import dev from './dev';
import testing from './testing';
import qa from './qa';
import prod from './prod';

let config = {};
switch (process.env.LEADMALL_ENV) {
  case 'development':
    config = dev;
    break;
  case 'testing':
    config = testing;
    break;
  case 'qa':
    config = qa;
    break;
  case 'production':
    config = prod;
    break;
  default:
    config = dev;
}

export default config;
window.config = config;



// WEBPACK FOOTER //
// ./src/config/index.js